import React from 'react';
import { Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import {
    ContactSection, BadgeListSection, SocialSection,
    AboutSection, ExperienceSection, EducationSection, ReferencesSection,
} from './PdfSections';

const HEADING = '#4169E1';

const styles = StyleSheet.create({
    page: { padding: 30, fontSize: 10, fontFamily: 'Helvetica' },
    name: { fontSize: 22, fontWeight: 'bold', textAlign: 'center' },
    title: { fontSize: 13, textAlign: 'center', marginBottom: 14 },
    row: { flexDirection: 'row' },
    col: { width: '50%', paddingRight: 15 },
});

function Template6Pdf(props) {
    const {
        name, about, email, address, phone, title,
        technicalSkills, languages, softSkills,
        linkedinURL, twitterURL, githubURL, websiteURL,
        educationData, jobData, showSocial, referenceData,
    } = props;

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap>
                <Text style={styles.name}>{name}</Text>
                <Text style={styles.title}>{title}</Text>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <AboutSection about={about} headingColor={HEADING} />
                        <ContactSection email={email} phone={phone} address={address} headingColor={HEADING} />
                        <SocialSection linkedinURL={linkedinURL} twitterURL={twitterURL} githubURL={githubURL} websiteURL={websiteURL} showSocial={showSocial} headingColor={HEADING} />
                        <BadgeListSection title="Professional Skills" items={technicalSkills} headingColor={HEADING} />
                        <BadgeListSection title="Soft Skills" items={softSkills} headingColor={HEADING} />
                        <BadgeListSection title="Languages Known" items={languages} headingColor={HEADING} />
                    </View>
                    <View style={styles.col}>
                        <ExperienceSection jobData={jobData} headingColor={HEADING} />
                        <EducationSection educationData={educationData} headingColor={HEADING} />
                        <ReferencesSection referenceData={referenceData} headingColor={HEADING} />
                    </View>
                </View>
            </Page>
        </Document>
    );
}

export default Template6Pdf;